import React from 'react';
import '../css/all.css';
import '../css/card.css';
import Bag from "../assests/bag.png";
import Track from "../assests/track.png";
import Sort from "../assests/sort.png";
import Git from "../assests/git.png";
export default class Projects extends React.Component {
  render() {
    return (
      <div className="projects container">
      <div className="row align-items-center">
             <div className="col  align-items-center">
                 
                 <div className="col  align-items-center name">
                            <h3 className="mb-4 mt-5" >Projects</h3>
                            <div className="row align-items-center ">
                              <div className="cardCustom container">
                              <div className="col align-self-center">
                                   <img alt="pic" src={Bag} width="30" className="mx-auto d-block mb-2"></img> 
                                   <div className="row">
                                   <p className="proHead">E commerece solution</p>
                                     <br></br>
                                       <p className="proSub">Using MERN stack</p>
                                     
                                   </div>
                                   </div>
                              </div>
                              <div className="cardCustom container mt-3">
                                   <div className="row align-items-center">
                                   <img alt="pic" src={Track} width="30" className="mx-auto d-block mb-2"></img> 
                                     <div className="row">
                                     <p className="proHead">Covid-19 cases tracker</p>
                                     <br></br>
                                       <p className="proSub">Using React & real time API</p>
                                     </div>
                                     
                                   </div>
                              </div>
                              <div className="cardCustom container mt-3">
                                   <div className="row align-items-center">
                                   <img alt="pic" src={Sort} width="30" className="mx-auto d-block mb-2"></img> 
                                     <div className="row">
                                     <p className="proHead">Sort visualizer</p>
                                     <br></br>
                                       <p className="proSub">Using React and styled components</p>
                                     </div>
                                     
                                   </div>
                              </div>
                              <div className="cardCustomCard container mt-4 mb-2">
                                   <div className="col align-items-center">
                                   <div className="row align-items-center"> <img alt="pic" src={Git} width="30" className="mx-auto d-block"></img></div>
                                   <div className="row container"><p className="more pl-2"><a href="https://github.com/satya7721">More at Github </a> </p></div>
                                  
                                   </div>
                              </div>
                            </div>
                            

                 </div>
             </div>
             </div>
      </div>
    );
  }
}